const NewVersionToast = () => {
	return (
		<div>
			<h4>🎉 New version published</h4>
			<p>There is a new found.center mobile agent version. Press reload.</p>
			<button
				className="btn btn-link"
				onClick={() => {
					const isStandalone =
						(window.navigator as any).standalone === true ||
						window.matchMedia("(display-mode: standalone)").matches;

					if (isStandalone) {
						alert("Please close and reopen the app to get the latest version.");
					} else {
						if (window.caches) {
							window.caches.keys().then((names) => {
								for (const name of names) {
									window.caches.delete(name);
								}
							});
						}
						window.location.reload();
					}
				}}
			>
				Reload
			</button>
		</div>
	);
};

export default NewVersionToast;
